import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext'
import { T } from './Translation'
import '../styles/CouponModal.css'

function CouponModal({ isOpen, onClose }) {
  const navigate = useNavigate()
  const { language } = useLanguage()

  const handleWithCoupon = () => {
    // Navigate to register directly - they can enter coupon code on the register page
    navigate('/register')
    onClose()
  }

  const handleWithoutCoupon = () => {
    // Prepare WhatsApp message based on language
    const message = language === 'he' 
      ? 'שלום! אני מעוניין/ת לשמוע עוד על השירותים שלכם לאירועים.'
      : 'Hello! I would like to learn more about your event services.'
    
    const phoneNumber = '972552642897'
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    
    // Open WhatsApp in a new tab
    window.open(whatsappUrl, '_blank')
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="coupon-modal-overlay" onClick={onClose}>
      <div className="coupon-modal" onClick={(e) => e.stopPropagation()}>
        <button className="coupon-modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="coupon-modal-content">
          <h2><T k="couponModalTitle" /></h2>
          <p><T k="couponModalSubtitle" /></p>
          
          <div className="coupon-buttons-section">
            <button 
              onClick={handleWithCoupon}
              className="coupon-button coupon-button-primary"
            >
              <T k="yesIHaveCoupon" />
            </button>
            
            <button 
              onClick={handleWithoutCoupon}
              className="coupon-button coupon-button-secondary"
            >
              <T k="noContactWhatsApp" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CouponModal
